module.exports = {"PHOTO_GRID_NOT_LOADED_IMAGES_MESSAGE":"No pudimos descargar algunas de las imágenes del post"}